import { Equipment } from 'hooks/useEquipment/types';

export interface SolutionItemData {
  imageUrl?: string | null;
  imagePath?: string;
  title?: string;
  descriptions: string[];
  count?: number | null;
  isError?: boolean;
  errorMessage?: string;
}

export interface BuildItemConfig {
  equipmentTypeId: number | null | undefined;
  equipment?: Equipment | null;
  placeholderImage: string;
  title: string; // Translated title instead of key
  manualDescriptions: string[];
  count?: number | null;
}

/**
 * Builds a solution item data structure for ProposedSolutionBox component.
 * Handles both catalog equipment (with ID) and manual mode (with placeholder).
 *
 * @param config - Configuration object containing equipment data and manual fallbacks
 * @returns SolutionItemData with image, title, and descriptions
 */
export const buildEquipmentItem = (config: BuildItemConfig): SolutionItemData => {
  const { equipmentTypeId, equipment, placeholderImage, title, manualDescriptions, count } = config;

  // From catalog - use equipment data
  if (equipmentTypeId && equipment) {
    const descriptions: string[] = [equipment.name];
    if (equipment.kvaValue) {
      descriptions.push(`${equipment.kvaValue} kVA`);
    }
    if (equipment.kwPower) {
      descriptions.push(`${equipment.kwPower} kW`);
    }
    if (equipment.kwhCapacity) {
      descriptions.push(`${equipment.kwhCapacity} kWh`);
    }
    return {
      imageUrl: equipment.imageUrl || equipment.image?.url || null,
      title,
      descriptions,
      count,
    };
  }

  // Manual mode or loading
  return {
    imagePath: placeholderImage,
    title,
    descriptions: manualDescriptions,
    count,
  };
};
